import img1 from '../../assets/img/blog-1.jpg';
import img2 from '../../assets/img/blog-2.jpg';
import img3 from '../../assets/img/blog-3.jpg';

const homeSec5Data = {
    homeSec5Data:[
        {
            id: 1,
            img: img1,
            title: "blog title goes here...",
            text: "Find everything you need for modern dining – tables, chairs, stools, storage and accessories – and save 15% during the Annual Dining Sale."
        },
        {
            id: 2,
            img: img2,
            title: "blog title goes here...",
            text: "Find everything you need for modern dining – tables, chairs, stools, storage and accessories – and save 15% during the Annual Dining Sale."
        },
        {
            id: 3,
            img: img3,
            title: "blog title goes here...",
            text: "Find everything you need for modern dining – tables, chairs, stools, storage and accessories – and save 15% during the Annual Dining Sale."
        },
    ]
}  

export default homeSec5Data